var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongCardDiamond({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".5vw",
    height: ".5vw",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37864 1.5957L3.52427 3.8093L5 8.40396M5 8.40396L6.51456 3.77046L5.69903 1.5957M5 8.40396L1 3.84813M5 8.40396L9 3.84813M1 3.84813L2.70874 1.5957H7.3301L9 3.84813M1 3.84813H9",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongCardDiamond);
export default __webpack_public_path__ + "static/media/long_card_diamond.619d8b5be96d5e1853af23f05e74348e.svg";
export { ForwardRef as ReactComponent };